/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable camelcase */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import {
  Form, Input, DatePicker, Col, Row, Grid,
} from 'antd';
import tooltips from './tooltips';
import links from './links';

import {
  CompanyField,
  ExpenseCategoryField,
  ExpenseSubCategory1Field,
  ExpenseSubCategory2Field,
  FileUploader,
  ModeOfPaymentField,
  PayeeField,
} from '../../components/Inputs';

import LabelToolTip from '../../components/Feedback/LabelToolTip';

const layout = {
  labelCol: {
    span: 8,
  },
  wrapperCol: {
    span: 16,
  },
};
const defaultRowStyle = {
  justify: 'start',
  gutter: {
    xs: 8, sm: 16, md: 24, lg: 32,
  },
  style: {
    paddingLeft: '10%',
    paddingRight: '10%',
  },
};
const defaultColStyle = {
  xs: {
    span: 24,
  },
  sm: {
    span: 8,
  },
};

const { useBreakpoint } = Grid;

function EPRHeaderSection({
  // attributes
  disabled,
  request,

  // methods
  onCategoryChange,
  onChange,
  onFileUpload,
}) {
  const screen = useBreakpoint();
  const [rowStyle, setRowStyle] = useState(defaultRowStyle);
  const [colStyle] = useState(defaultColStyle);

  const {
    company_code,
    category,
    subcategory_1,
    particulars,
    date_payable,
    billing_period_from,
    billing_period_to,
    payee_code,
    ref_no,
  } = request;

  useEffect(() => {
    if (screen.xs) {
      setRowStyle((currRowStyle) => ({
        ...currRowStyle,
        style: {
          paddingLeft: '5%',
          paddingRight: '5%',
        },
      }));
      return;
    }
    setRowStyle(defaultRowStyle);
  }, [screen]);

  return (
    <>
      <Row {...rowStyle}>
        <Col {...colStyle}>
          <Form.Item
            name="company"
            label={<LabelToolTip label={`Company ${company_code ? `(${company_code})` : ''}`} tip={tooltips.company} />}
          >
            <CompanyField
              disabled={disabled}
              onInputSelect={({
                company_code: comp_code,
                company_name: comp_name,
              }) => {
                onChange({
                  ...request,
                  company_code: comp_code,
                  company_name: comp_name,
                  category: '',
                  subcategory_1: '',
                  subcategory_2: '',
                });
                onCategoryChange({
                  category: '',
                  subcategory_1: '',
                  subcategory_2: '',
                });
              }}
            />
          </Form.Item>
        </Col>
      </Row>

      <Row {...rowStyle}>
        <Col {...colStyle}>
          <Form.Item
            name="payee"
            label={<LabelToolTip label={`Payee ${payee_code ? `(${payee_code})` : ''}`} tip={tooltips.payee} />}
          >
            <PayeeField
              placeholder="Please choose a Payee"
              disabled={disabled}
              companyCode={company_code}
              onInputSelect={({ pay_group_lookup_code, vendor_name, code }) => {
                onChange({
                  ...request,
                  payee_paygroup: pay_group_lookup_code,
                  payee_desc: vendor_name,
                  payee_code: code,
                });
              }}
            />

            <small>
              <a href={links.suppliers} target="_blank">
                Click here to view the full list
              </a>
              <br />
            </small>
          </Form.Item>
        </Col>
        <Col {...colStyle}>
          <Form.Item
            name="billing_period_from"
            label={<LabelToolTip label="Billing Period From" tip={tooltips.billingPeriod} />}
          >
            <DatePicker
              disabled={disabled}
              style={{ width: '100%' }}
              value={billing_period_from}
              onChange={(value) => {
                onChange({
                  ...request,
                  billing_period_from: value ? value.format() : '',
                });
              }}
            />
          </Form.Item>
        </Col>
        <Col {...colStyle}>
          <Form.Item
            name="billing_period_to"
            label={<LabelToolTip label="Billing Period To" tip={tooltips.billingPeriod} />}
          >
            <DatePicker
              disabled={disabled}
              style={{ width: '100%' }}
              value={billing_period_to}
              onChange={(value) => {
                onChange({
                  ...request,
                  billing_period_to: value ? value.format() : '',
                });
              }}
            />
          </Form.Item>
        </Col>
      </Row>

      <Row {
        ...rowStyle
      }
      >
        <Col {...colStyle}>
          <Form.Item
            name="date_payable"
            label={<LabelToolTip label="Date Payable" tip={tooltips.datePayable} />}
          >
            <DatePicker
              disabled={disabled}
              style={{ width: '100%' }}
              value={date_payable}
              onChange={(value) => {
                onChange({
                  ...request,
                  date_payable: value ? value.format() : '',
                });
              }}
            />
          </Form.Item>
        </Col>
        <Col {...colStyle}>
          <Form.Item
            name="mode_of_payment"
            label={<LabelToolTip label="Mode of Payment" tip={tooltips.modeOfPayment} />}
          >
            <ModeOfPaymentField
              placeholder="Please choose a Mode of Payment"
              disabled={disabled}
              onInputSelect={(mode_of_payment) => {
                onChange({
                  ...request,
                  mode_of_payment,
                });
              }}
            />
          </Form.Item>
        </Col>
      </Row>

      <Row {...rowStyle}>
        <Col {...colStyle}>
          <Form.Item
            name="category"
            label={<LabelToolTip label="Category" tip={tooltips.category} />}
          >
            <ExpenseCategoryField
              placeholder="Please choose a Company first"
              disabled={disabled}
              config={{ company_code }}
              onInputSelect={({ category: cat }) => {
                if (category === cat) {
                  return;
                }
                onChange({
                  ...request,
                  category: cat,
                  subcategory_1: '',
                  subcategory_2: '',
                });
                onCategoryChange({
                  subcategory_1: '',
                  subcategory_2: '',
                });
              }}
            />

            <small>
              <a href={links.accountingEntries} target="_blank">
                Click here to view the full list
              </a>
            </small>
          </Form.Item>
        </Col>
        <Col {...colStyle}>
          <Form.Item
            name="subcategory_1"
            label={<LabelToolTip label="Subcategory 1" tip={tooltips.subcategory1} />}
          >
            <ExpenseSubCategory1Field
              placeholder="Please choose a Category first"
              disabled={disabled}
              config={{
                company_code,
                category,
              }}
              onInputSelect={({ subcategory_1: subcat1 }) => {
                if (subcat1 === subcategory_1) {
                  return;
                }
                onChange({
                  ...request,
                  subcategory_1: subcat1,
                  subcategory_2: '',
                });
                onCategoryChange({
                  subcategory_1: subcat1,
                  subcategory_2: '',
                });
              }}
            />

            <small>
              <a href={links.accountingEntries} target="_blank">
                Click here to view the full list
              </a>
            </small>
          </Form.Item>
        </Col>
        <Col {...colStyle}>
          <Form.Item
            name="subcategory_2"
            label={<LabelToolTip label="Subcategory 2" tip={tooltips.subcategory2} />}
          >
            <ExpenseSubCategory2Field
              placeholder="Please choose a Subcategory 1 first"
              disabled={disabled}
              config={{
                company_code,
                category,
                subcategory_1,
              }}
              onInputSelect={({ subcategory_2, accounting_processors }) => {
                onChange({
                  ...request,
                  subcategory_2,
                  accounting_processors,
                });
              }}
            />

            <small>
              <a href={links.accountingEntries} target="_blank">
                Click here to view the full list
              </a>
            </small>
          </Form.Item>
        </Col>
      </Row>

      <Row {...rowStyle}>
        <Col {...colStyle}>
          <Form.Item
            name="reference_no"
            label={<LabelToolTip label="Reference no." tip={tooltips.referenceNo} />}
          >
            <Input.TextArea
              disabled={disabled}
              value={ref_no}
              onBlur={(event) => {
                onChange({
                  ...request,
                  ref_no: event.target.value,
                });
              }}
            />
          </Form.Item>
        </Col>

        <Col {...colStyle}>
          <Form.Item
            name="attachment"
            label={<LabelToolTip label="Attachment" tip={tooltips.attachment} />}
            wrapperCol={{ ...layout.wrapperCol }}
          >
            <FileUploader
              config={{ dataset: 'expense-payment-request' }}
              onUpload={(uploading) => {
                onFileUpload(uploading);
              }}
              onRemove={(attachment) => {
                onChange({
                  ...request,
                  attachment,
                });
              }}
              onFinishUpload={(attachment) => {
                onChange({
                  ...request,
                  attachment,
                });
              }}
            />
          </Form.Item>
        </Col>
      </Row>

      <Row {...rowStyle}>
        <Col {...{ ...colStyle, sm: { span: 16 } }}>
          <Form.Item
            name="particulars"
            label={<LabelToolTip label="Particulars" tip={tooltips.particulars} />}
          >
            <Input.TextArea
              rows={4}
              disabled={disabled}
              value={particulars}
              onBlur={(event) => {
                onChange({
                  ...request,
                  particulars: event.target.value,
                });
              }}
            />
          </Form.Item>
        </Col>
      </Row>
    </>
  );
}

export default EPRHeaderSection;
